import React from 'react';
import {connect} from 'react-redux';
import {injectIntl} from 'react-intl';
import {InputNumber, Form, Modal, Button, Spin, Icon} from "antd";
import {getCommissions, updateCommissions,} from "../../../actions/AffiliateActions";

class Settings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            settingsVisible: false,
            onlyNegativeCommissions: [1, 3]
        };
    }

    showSettingsModal = () => {

        this.props.dispatch(getCommissions(this.props.affiliateId));

        this.setState({
            settingsVisible: true,
        });
    };

    handleCancel = e => {
        this.setState({
            settingsVisible: false,
        });
    };

    handleSubmit = (form) => {

        //Validate completed data
        form.validateFields((err, values) => {

            const updateCommissionsData = {
                AffiliateId: this.props.affiliateId,
                Commissions: values
            };

            if (!err) {
                this.props.dispatch(updateCommissions(updateCommissionsData, this.props.intl)).then(
                    () => {
                        if (!this.props.affiliates.commissions.error) {
                            this.setState({
                                settingsVisible: false
                            });
                        }
                    })
            }
        });
    };

    formatInput = (input, value) => {
        if (typeof value === 'string') {
            const dotIndex = value.indexOf('.');
            if (
                (value.endsWith('.') && dotIndex !== value.length - 1)
                || (dotIndex > -1 && value.length - dotIndex - 1 > 2)
            ) {
                value = value.slice(0, -1)
            }
            if (value.length - dotIndex - 1 > 2) {
                value.slice(0, -1)
            }
            if (value.startsWith('-')) {
                value = value.slice(1);
            }
        }
        return this.state.onlyNegativeCommissions.includes(input) ? `-${Math.abs(value)}%` : `${value}%`;
    };

    render() {

        const {commissions} = this.props.affiliates;

        const {getFieldDecorator} = this.props.form;

        const antIcon = <Icon type="loading" className="ta--ant_loader" spin/>;

        return (
            <React.Fragment key='settings-popup'>

                <Button className='clear_button_style' onClick={this.showSettingsModal}>
                    {this.props.intl.messages.settings}
                </Button>

                {/* Settings Modal */}
                <Modal
                    className='settings-form'
                    title={this.props.intl.messages.settings}
                    visible={this.state.settingsVisible}
                    centered
                    onCancel={this.handleCancel}
                    footer={[
                        <React.Fragment key='settings-buttons'>
                        <Button onClick={this.handleCancel} key="next">{this.props.intl.messages.cancel}</Button>
                        <Button onClick={this.handleSubmit.bind(this, this.props.form)} key="save"
                        type="primary">{this.props.intl.messages.save}</Button>
                        </React.Fragment>
                    ]}
                    >
                    
                    <Spin indicator={antIcon} spinning={this.props.affiliates.inProcess}>
                    <Form layout="vertical" className='ta--ph-12 ta--settings-modal ta-w100 settings-form'>
                    {commissions && Object.keys(commissions).map(key => {
                                return (
                                        <Form.Item className='settings-form-item' label={commissions[key].CommissionName} key={key}>
                                            {getFieldDecorator(`${commissions[key].CommissionId}`, {
                                                initialValue: commissions[key].Share,
                                            })(
                                                <InputNumber placeholder="Type Here" className="ta-w100"
                                                             min={this.state.onlyNegativeCommissions.includes(commissions[key].CommissionId) ? -100 : 0}
                                                             max={this.state.onlyNegativeCommissions.includes(commissions[key].CommissionId) ? 0 : 100}
                                                             formatter={value => this.formatInput(commissions[key].CommissionId, value)}
                                                             parser={value => value.replace(/[^0-9.-]/g, '')}/>
                                            )}
                                        </Form.Item>
                                )
                            })}
                        </Form>
                    </Spin>
                </Modal>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        affiliates: state.affiliates
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
};

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(Settings)));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Affiliates/Settings.js